import EditCard from '@anm/components/credit-card/EditCard';
import { CardZipCodeField, EmailField } from '@anm/components/form/fields';
import {
  composeValidators,
  email,
  required
} from '@anm/components/form/validators';
import { FC, ReactNode } from 'react';

import {
  CardZipCodeFieldWrapper,
  EditCardFormBlock,
  EditCardFormRow,
  EditCardFormRowItem,
  EditCardFormWrapper,
  EmailFieldExtraDescription,
  EmailFieldRow,
  EmailFiledWrapper
} from './Wrapper';

export type EditCardBlockProps = {
  additionalField?: ReactNode;
};

const EditCardBlock: FC<EditCardBlockProps> = ({ additionalField }) => (
  <EditCardFormWrapper>
    <EditCardFormBlock>
      <EditCard />
      <EditCardFormRow>
        <EditCardFormRowItem>
          <CardZipCodeFieldWrapper>
            <CardZipCodeField
              inputVariant="simple-small"
              labelVariant="static-above-dark-uppercase"
            />
          </CardZipCodeFieldWrapper>
        </EditCardFormRowItem>
        <EditCardFormRowItem>{additionalField}</EditCardFormRowItem>
      </EditCardFormRow>
      <EmailFieldRow>
        <EmailFiledWrapper>
          <EmailField
            required
            validate={composeValidators(required('Email is required'), email)}
            autoFocus={false}
            showError={false}
            inputVariant="simple-small"
            labelVariant="static-above-dark-uppercase"
          />
        </EmailFiledWrapper>

        <EmailFieldExtraDescription>
          We will send your payment confirmation
        </EmailFieldExtraDescription>
      </EmailFieldRow>
    </EditCardFormBlock>
  </EditCardFormWrapper>
);

export default EditCardBlock;
